/**
 * Componente React de cada página migrada, pelo slug do legado. Ao migrar uma página:
 * acrescentar aqui e trocar o `status` dela para 'migrada' em `paginas.ts` (um teste
 * garante que os dois ficam em sincronia).
 */
import type { ComponentType } from 'react';

import { BrasilAsset } from '../pages/acompanhamentos/BrasilAsset';
import { CapitalMarketAssumptions } from '../pages/acompanhamentos/CapitalMarketAssumptions';
import { ComiteInvestimentos } from '../pages/acompanhamentos/ComiteInvestimentos';
import { ProjecoesAnbima } from '../pages/acompanhamentos/ProjecoesAnbima';
import { AlocacaoRbs } from '../pages/carteiras/AlocacaoRbs';
import { CarteirasModeloPortfolio } from '../pages/carteiras/CarteirasModeloPortfolio';
import { Comparador } from '../pages/carteiras/Comparador';
import { ControlePosicoes } from '../pages/carteiras/ControlePosicoes';
import { OperacoesLote } from '../pages/carteiras/OperacoesLote';
import { OtimizadorAlocacao } from '../pages/carteiras/OtimizadorAlocacao';
import { Rebalanceador } from '../pages/carteiras/Rebalanceador';
import { XBridge } from '../pages/carteiras/XBridge';
import { ControleVencimentos } from '../pages/carteiras/ControleVencimentos';
import { Distribuicao } from '../pages/carteiras/Distribuicao';
import { MonitorFgc } from '../pages/carteiras/MonitorFgc';
import { Performance } from '../pages/carteiras/Performance';
import { PlanejamentoFinanceiro } from '../pages/carteiras/PlanejamentoFinanceiro';
import { Precificacao } from '../pages/credito/Precificacao';
import { SpreadsCredito } from '../pages/credito/SpreadsCredito';
import { SpreadsPorEmissor } from '../pages/credito/SpreadsPorEmissor';
import { B3Fluxo } from '../pages/equities/B3Fluxo';
import { MarketBreadth } from '../pages/equities/MarketBreadth';
import { Screener } from '../pages/equities/Screener';
import { Valuation } from '../pages/equities/Valuation';
import { PeerGroup } from '../pages/fundos/PeerGroup';
import { Scorecard } from '../pages/fundos/Scorecard';
import { FactorInvesting } from '../pages/quant/FactorInvesting';
import { PortfolioBacktester } from '../pages/quant/PortfolioBacktester';
import { CalendarioEconomico } from '../pages/utilitarios/CalendarioEconomico';
import { ExtracaoDados } from '../pages/utilitarios/ExtracaoDados';
import { GeradorGraficos } from '../pages/utilitarios/GeradorGraficos';
import { Hora360 } from '../pages/utilitarios/Hora360';

export const COMPONENTES: Record<string, ComponentType> = {
  'analise-quantitativa_factor-investing': FactorInvesting,
  'analise-quantitativa_portfolio-backtester': PortfolioBacktester,
  'acompanhamentos-periodicos_brasil-asset-iii': BrasilAsset,
  'acompanhamentos-periodicos_capital-market-assumptions': CapitalMarketAssumptions,
  'acompanhamentos-periodicos_comite-de-investimentos': ComiteInvestimentos,
  'acompanhamentos-periodicos_projecoes-anbima': ProjecoesAnbima,
  'carteiras-administradas_alocacao-rbs': AlocacaoRbs,
  'carteiras-administradas_carteiras-modelo-portfolio': CarteirasModeloPortfolio,
  'carteiras-administradas_comparador': Comparador,
  'carteiras-administradas_controle-de-posicoes': ControlePosicoes,
  'carteiras-administradas_otimizador-de-alocacao': OtimizadorAlocacao,
  'carteiras-administradas_operacoes-em-lote': OperacoesLote,
  'carteiras-administradas_carteiras-modelo-rebalanceador': Rebalanceador,
  'carteiras-administradas_xbridge': XBridge,
  'carteiras-administradas_controle-de-vencimentos': ControleVencimentos,
  'carteiras-administradas_distribuicao': Distribuicao,
  'carteiras-administradas_monitor-fgc': MonitorFgc,
  'carteiras-administradas_performance': Performance,
  'carteiras-administradas_planejamento-financeiro': PlanejamentoFinanceiro,
  'credito-privado_precificacao': Precificacao,
  'credito-privado_spreads-de-credito': SpreadsCredito,
  'credito-privado_spreads-por-emissor': SpreadsPorEmissor,
  'equities_b3-fluxo-de-investidores': B3Fluxo,
  'equities_market-breadth': MarketBreadth,
  equities_screener: Screener,
  equities_valuation: Valuation,
  'fundos_peer-group': PeerGroup,
  'fundos_selecao-scorecard': Scorecard,
  'utilitarios_calendario-economico': CalendarioEconomico,
  'utilitarios_extracao-de-dados': ExtracaoDados,
  'utilitarios_gerador-de-graficos': GeradorGraficos,
  'utilitarios_hora-360': Hora360,
};
